import axios from 'axios'
import { LocalStorageService } from '../services'


class FollowUpContractsService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }

    url = process.env.REACT_APP_MIFIRMA_API
    localStorageService = new LocalStorageService()

    async getContractMonitoring(token) {
        let response = await axios.get(`${this.apiUrl}/contract-monitoring`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data
    }


    async getContractStatus(token) {
        let response = await axios.get(`${this.apiUrl}/status-contract`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data.data
    }


    async getContractFilter(token, abogadoId, solicitanteId, dateStart, dateEnd, timezone) {
        let response = await axios.get(`${this.apiUrl}/contract-filter?abogadoId=${abogadoId}&solicitanteId=${solicitanteId}&dateStart=${dateStart}&dateEnd=${dateEnd}&timezone=${timezone}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data.data
    }


}

export { FollowUpContractsService as default }